import Table from "../../Components/Table";
import StatusHandler from "../../Components/Table/StatusHandler";
import useFetchData from "../../Hooks/useFetchData";
import useTableControls from "../../Hooks/useTableControls";
import { getFeedbacks } from "../../Services/Feedback";
import { getReports } from "../../Services/Reports";
import { format_date, getSerialNumber } from "../../Utils/helpers";
import PageHeader from "../../Components/PageHeader";
import { formatBookingCode } from "../../Utils/bookingCode";

export default function Reports() {
  // const sampleData = [
  //   {
  //     sn: "1",
  //     fullName: "Mark Carson",
  //     userType: "User",
  //     datePosted: "01/02/2022",
  //     email: "abc@xyz.com",
  //   },
  //   {
  //     sn: "2",
  //     fullName: "Mark Carson",
  //     userType: "User",
  //     datePosted: "01/02/2022",
  //     email: "abc@xyz.com",
  //   },
  //   {
  //     sn: "3",
  //     fullName: "Mark Carson",
  //     userType: "User",
  //     datePosted: "01/02/2022",
  //     email: "abc@xyz.com",
  //   },
  //   {
  //     sn: "4",
  //     fullName: "Mark Carson",
  //     userType: "User",
  //     datePosted: "01/02/2022",
  //     email: "abc@xyz.com",
  //   },
  // ];

  const {
    perPage,
    setPerPage,
    status,
    setStatus,
    search_string,
    setSearchString,
    from,
    setFrom,
    to,
    setTo,
  } = useTableControls();

  const {
    // INTERNAL EXPORTS
    page,
    setPage,
    // REACT QUERY EXPORTS
    isFetching,
    isLoading,
    data,
    refetch,
  } = useFetchData("reports_logs", getReports, [
    perPage,
    search_string,
    from,
    to,
  ]);
  // console.log("feedback_logs Data: ", data?.data);

  return (
    <div className="app-content content">
      <div className="content-wrapper">
        <div className="content-body">
          {/* Basic form layout section start */}
          <section id="configuration">
            <div className="row">
              <div className="col-12">
                <div className="user-details-wrapper">
                  <PageHeader
                    title="Reports"
                    subtitle="Review incident reports, booking disputes, and service flags"
                  />
                  <Table
                    key={"feedbacks-table"}
                    nosearch
                    tableTitles={[
                      "S.No.",
                      "Booking Id",
                      "Reported By",
                      "Driver Name",
                      "Type",
                      "Date Posted",
                      "Action",
                    ]}
                    dateFilter
                    showEntries
                    // sortBy
                    isLoading={isLoading}
                    isFetching={isFetching}
                    data={data?.data?.data?.docs}
                    totalPages={Math.ceil(data?.data?.data?.totalPages || 0)}
                    totalDocs={data?.data?.data?.totalDocs}
                    page={page}

                    setPage={setPage}
                    setSearchString={setSearchString}
                    status={status}
                    setStatus={setStatus}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    from={from}
                    setFrom={setFrom}
                    to={to}
                    setTo={setTo}
                  >
                    {data?.data?.data?.docs?.map((item, index) => (
                        <tr key={item?._id || index}>

                          <td>{getSerialNumber(data?.data?.data, index)}</td>
                          <td>{formatBookingCode(item?.bookingId)}</td>
                          <td>{item?.reportedBy?.firstName}</td>
                          <td>{item?.bookingId?.driver?.firstName}</td>
                          <td>{item?.type}</td>
                          <td>
                            {item?.createdAt &&
                              format_date(item?.createdAt, "MM/DD/YYYY")}
                          </td>
                          <td>
                            <StatusHandler
                              key={`${item?._id}-status`}
                              view
                              item={item}
                              redirectUrl={`/reports/reports-details/${item?._id}`}
                            />
                          </td>
                        </tr>
                      ))}
                  </Table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
            <style>{`
                .fw-800 { font-weight: 800; }
                .w-100-mobile { width: 100% !important; text-align: center; justify-content: center; }
                
                @media (max-width: 576px) {
                    .w-100-mobile { width: 100% !important; text-align: center; justify-content: center; }
                    .user-details-wrapper { padding: 0.5rem; }
                }
            `}</style>
    </div>
  );
}
